// PDFReportDocument.js
import { Fragment } from "react";
import { Document, Page, Text, View } from "@react-pdf/renderer";

const PDFReportDocument = ({
  title,
  headings,
  data,
  columnWidth,
  startDate,
  endDate,
  variableColumnWidthsArray,
  columnWidthTypeRadioValue,
  headingsAndDataFontSize,
  sumAndAvgFontSize,
  columnSums,
  columnAverages,
  showSUMRow,
  showAVGRow,
  headingsSpacing,
  dataSpacing,
  isDownload,
}) => {
  const ROWS_PER_PDF_PAGE = 40;

  const pages = [];

  const headerView = (
    <View
      fixed
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 10,
        fontWeight: 500,
        marginBottom: 10,
      }}
    >
      <Text>{title}</Text>
      <Text>{startDate && endDate ? `${startDate} - ${endDate}` : ""}</Text>
    </View>
  );

  const headingsRow = (
    <View
      fixed
      style={{
        flexDirection: "row",
        borderBottom: "2px solid #089BAB",
        paddingVertical: 12,
      }}
    >
      {headings.map((heading, i) => {
        let width =
          columnWidthTypeRadioValue === 1
            ? variableColumnWidthsArray[i]
            : columnWidthTypeRadioValue === 2
              ? columnWidth
              : headingsSpacing[i].columnWidth;

        return (
          <Text
            key={i}
            style={{
              width,
              fontSize: headingsAndDataFontSize,
              fontWeight: 500,
              paddingRight: 5,
            }}
          >
            {heading}
          </Text>
        );
      })}
    </View>
  );

  for (let i = 0; i < data.length; i += ROWS_PER_PDF_PAGE) {
    const pageRows = data.slice(i, i + ROWS_PER_PDF_PAGE);
    const isLastPage = i + ROWS_PER_PDF_PAGE >= data.length;

    pages.push(
      <Page
        key={i}
        size="LETTER"
        orientation="landscape"
        style={{ padding: 20, fontFamily: "Poppins" }}
      >
        {headerView}
        {headingsRow}
        {pageRows.map((row, rIdx) => (
          <View
            key={rIdx}
            style={{
              flexDirection: "row",
              backgroundColor: rIdx % 2 ? "#EBEDF8" : "#FFFFFF",
              paddingVertical: 5,
            }}
          >
            {row.map((cell, cIdx) => {
              let width =
                columnWidthTypeRadioValue === 1
                  ? variableColumnWidthsArray[cIdx]
                  : columnWidthTypeRadioValue === 2
                    ? columnWidth
                    : dataSpacing[cIdx].columnWidth;

              return (
                <Text
                  key={cIdx}
                  style={{
                    width,
                    fontSize: headingsAndDataFontSize,
                    paddingRight: 5,
                  }}
                >
                  {cell}
                </Text>
              );
            })}
          </View>
        ))}
        <Text
          fixed
          style={{
            position: "absolute",
            bottom: 6,
            width: "100%",
            textAlign: "center",
            fontSize: 10,
          }}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />

        {isDownload && isLastPage && (
          <Fragment>
            {showSUMRow && (
              <>
                <Text
                  style={{
                    fontSize: sumAndAvgFontSize,
                    fontWeight: 500,
                    color: "#089BAB",
                    paddingTop: 12,
                  }}
                >
                  Sum
                </Text>
                <View style={{ flexDirection: "row", paddingTop: 10 }}>
                  {columnSums.map((total, i) => (
                    <Text
                      key={i}
                      style={{
                        width: variableColumnWidthsArray[i],
                        fontSize: sumAndAvgFontSize,
                        paddingRight: 5,
                      }}
                    >
                      {total >= 0
                        ? total.toFixed(2).replace(/(\.\d*[1-9])0+$/, "$1")
                        : "--"}
                    </Text>
                  ))}
                </View>
              </>
            )}
            {showAVGRow && (
              <>
                <Text
                  style={{
                    fontSize: sumAndAvgFontSize,
                    fontWeight: 500,
                    color: "#089BAB",
                    paddingTop: 12,
                  }}
                >
                  Average
                </Text>
                <View style={{ flexDirection: "row", paddingTop: 10 }}>
                  {columnAverages.map((total, i) => (
                    <Text
                      key={i}
                      style={{
                        width: variableColumnWidthsArray[i],
                        fontSize: sumAndAvgFontSize,
                        paddingRight: 5,
                      }}
                    >
                      {total >= 0
                        ? total.toFixed(2).replace(/(\.\d*[1-9])0+$/, "$1")
                        : "--"}
                    </Text>
                  ))}
                </View>
              </>
            )}
          </Fragment>
        )}
      </Page>,
    );
  }

  return <Document title={title}>{pages}</Document>;
};

export default PDFReportDocument;
